const CHANGE_USERINFO = 'CHANGE_USERINFO';
import MessageService from 'message-service/message-service';
import DistEvents from '@gameday/core/events/DistEvents';
const { ACCESS_TOKEN_CHANGE } = DistEvents;

const changeUserInfoAction = (userinfo) => (dispatch, getState) => {
    const state = getState();
    const { accessToken } = userinfo;

    if (state?.userinfo?.accessToken !== accessToken) {
        MessageService.publish(ACCESS_TOKEN_CHANGE, accessToken);
    }

    dispatch({
        type: CHANGE_USERINFO,
        userinfo
    });
   
};

export default changeUserInfoAction;